<template>
  <div>
    <!-- <AntigoDashboardInfo class="mb-8" /> -->
    <b-row class="px-4">
      <div
        class="card card-custom bg-light-warning card-stretch gutter-b p-4"
        v-if="certificadoVencidoMsg"
      >
        <p class="mb-0 font-weight-bolder">
          <Warning :size="20" />
          {{ certificadoVencidoMsg }}
          <strong
            ><a
              href="https://wa.me/554935500600?text=Quero saber mais sobre o certificado digital!"
              target="_blank"
            >
              Clique Aqui</a
            ></strong
          >
        </p>
      </div>
    </b-row>
    <b-row class="px-4 blinking-row">
      <div
        class="card card-custom bg-light-danger card-stretch gutter-b p-4"
        v-if="licenca.apresentar_renovacao"
      >
        <p class="mb-0 font-weight-bolder">
          <Warning :size="20" />
          Sua assinatura está prestes a vencer nos próximos dias, realize a sua
          renovação automaticamente:
          <strong>
            <a @click="$router.push({ name: 'assinatura' })">
              Para realizar a renovação agora, clique aqui!
            </a>
          </strong>
        </p>
      </div>
    </b-row>
    <b-row>
      <div class="col-12 d-flex justify-content-center">
        <div class="w-100">
          <b-row>
            <div class="col-md-4 mb-8">
              <Totalizador
                class="dash-widget"
                :totais-cadastros="totais_cadastros"
                :loading="loadingTotais"
              />
            </div>
            <div class="col-md-8 mb-8" v-if="userAccessStore.access.financeiro">
              <TotalizadorContas
                class="dash-widget"
                :totaisFinanceiros="totais_financeiros"
                :loading="loadingTotais"
              />
            </div>
          </b-row>
          <b-row v-if="currentUser.admin">
            <div class="col-md-4 mb-8">
              <TicketMedio
                class="dash-widget"
                :ticketMedio="ticketMedio"
                :loading="loadingTicketMedio"
                :periodo="tmPeriodo"
                :ignore-initial-apply="true"
                @change-periodo="onPeriodoChange('ticketMedio', $event)"
              />
            </div>
            <div class="col-md-4 mb-8">
              <MargemLucro
                class="dash-widget"
                :margemLucro="margemLucro"
                :periodo="margemPeriodo"
                :loading="loadingMargemLucro"
                :ignore-initial-apply="true"
                @change-periodo="onPeriodoChange('margemLucro', $event)"
              />
            </div>
            <div class="col-md-4 mb-8">
              <Vendas
                class="dash-widget"
                :valorVendas="valorVendas"
                :periodo="vendasPeriodo"
                :loading="loadingValorVendas"
                :ignore-initial-apply="true"
                @change-periodo="onPeriodoChange('valorVendas', $event)"
              />
            </div>
          </b-row>
          <b-row v-if="currentUser.admin">
            <div class="col-md-4">
              <b-row>
                <div class="col-12 mb-8">
                  <MetaFaturamento :loading="loadingMeta" :dados="metaMensal" />
                </div>
                <div class="col-12 mb-8">
                  <Inadimplencia
                    class="dash-widget"
                    :loading="loadingInadimplencia"
                    :inadimplencia="inadimplencia"
                    :periodo="inadimplenciaPeriodo"
                    :ignore-initial-apply="true"
                    @change-periodo="onPeriodoChange('inadimplencia', $event)"
                  />
                </div>
              </b-row>
            </div>
            <div class="col-md-8">
              <b-row>
                <div class="col-12 col-xxxl-6 mb-8">
                  <RelacaoFinanceira
                    class="dash-widget"
                    :dados="relacaoFinanceira"
                    :periodo="relacaoFinanceiraPeriodo"
                    :loading="loadingRelacaoFinanceira"
                    :ignore-initial-apply="true"
                    @change-periodo="
                      onPeriodoChange('relacaoFinanceira', $event)
                    "
                  />
                </div>
                <div class="col-12 col-xxxl-6 mb-8">
                  <GraficoVendas
                    class="dash-widget"
                    :dados="relacaoVendas"
                    :loading="loadingGraficoVendas"
                    :ignore-initial-apply="true"
                    @change-comparacao="onComparacaoVendas"
                  />
                </div>
              </b-row>
            </div>
          </b-row>
        </div>
        <div style="width: 250px" class="d-none ml-8 d-lg-block">
          <Atalhos />
        </div>
        <div class="d-block d-lg-none">
          <FabAtalhos />
        </div>
      </div>
    </b-row>
    <b-row v-if="currentUser.admin">
      <div class="col-md-5 col-xxxl-4 mb-8">
        <Aniversariantes
          class="dash-widget h-100"
          :dados="aniversariantes"
          :loading="loadingAniversariantes"
        />
      </div>
      <div class="col-md-6 col-xxxl-4 mb-8">
        <TopProdutosVendidos
          class="dash-widget"
          :dados="produtosMaisVendidos"
          :periodo="produtosPeriodo"
          :loading="loadingTopProdutos"
          :ignore-initial-apply="true"
          @change-periodo="onPeriodoChange('produtosMaisVendidos', $event)"
        />
      </div>
      <div class="col-md-6 col-xxxl-4 mb-8">
        <TopClientes
          class="dash-widget"
          :dados="clientesTop"
          :periodo="clientesPeriodo"
          :loading="loadingMaioresClientes"
          :ignore-initial-apply="true"
          @change-periodo="onPeriodoChange('clientesTop', $event)"
        />
      </div>
    </b-row>
  </div>
</template>

<script>
import Aniversariantes from "../components/Aniversariantes.vue";
// import AntigoDashboardInfo from "../components/AntigoDashboardInfo.vue";
import Atalhos from "../components/Atalhos.vue";
import FabAtalhos from "../components/FabAtalhos.vue";
import GraficoVendas from "../components/GraficoVendas.vue";
import Inadimplencia from "../components/Inadimplencia.vue";
import MargemLucro from "../components/MargemLucro.vue";
import MetaFaturamento from "../components/MetaFaturamento.vue";
import RelacaoFinanceira from "../components/RelacaoFinanceira.vue";
import TicketMedio from "../components/TicketMedio.vue";
import TopClientes from "../components/TopClientes.vue";
import TopProdutosVendidos from "../components/TopProdutosVendidos.vue";
import Totalizador from "../components/Totalizador.vue";
import TotalizadorContas from "../components/TotalizadorContas.vue";
import Vendas from "../components/Vendas.vue";
import { mapGetters } from "vuex";
import { userAccessStore } from "@/userAccessStore";

export default {
  name: "app-dashboard-v2",
  components: {
    RelacaoFinanceira,
    Vendas,
    TopProdutosVendidos,
    Aniversariantes,
    Totalizador,
    Atalhos,
    GraficoVendas,
    MetaFaturamento,
    TicketMedio,
    Inadimplencia,
    TopClientes,
    MargemLucro,
    FabAtalhos,
    // AntigoDashboardInfo,
    TotalizadorContas,
  },

  data() {
    const todayISO = () => {
      const d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().slice(0, 10);
    };
    const last7DaysRangeISO = () => {
      const end = new Date(); // hoje
      const start = new Date(); // hoje - 6 dias
      start.setDate(end.getDate() - 6);

      // corrige timezone local
      start.setMinutes(start.getMinutes() - start.getTimezoneOffset());
      end.setMinutes(end.getMinutes() - end.getTimezoneOffset());

      return {
        inicio: start.toISOString().slice(0, 10),
        fim: end.toISOString().slice(0, 10),
      };
    };
    const hoje = todayISO();
    const semana = last7DaysRangeISO();

    return {
      dash: null,
      loadingTotais: false,
      loadingTicketMedio: false,
      loadingMargemLucro: false,
      loadingValorVendas: false,
      loadingInadimplencia: false,
      loadingRelacaoFinanceira: false,
      loadingAniversariantes: false,
      loadingTopProdutos: false,
      loadingMaioresClientes: false,
      loadingGraficoVendas: false,
      loadingMeta: false,
      error: null,
      cancelSource: null, // evita corrida de requests se filtros mudarem rápido
      totais_cadastros: null,
      totais_financeiros: null,
      ticketMedio: 0,
      margemLucro: 0,
      valorVendas: 0,
      inadimplencia: null,
      relacaoFinanceira: null,
      aniversariantes: null,
      topProdutosVendidos: null,
      clientesTop: null,
      metaMensal: null,
      relacaoVendas: [],
      filtros: { inicio_tm: hoje, fim_tm: hoje },
      tmPeriodo: null,
      margemPeriodo: null,
      vendasPeriodo: null,
      inadimplenciaPeriodo: null,
      relacaoFinanceiraPeriodo: null,
      produtosPeriodo: null,
      clientesPeriodo: null,
      semana: semana,
      userAccessStore,
      certificadoVencidoMsg: "",
    };
  },
  computed: {
    ...mapGetters(["licenca"]),
    INDICADORES() {
      return {
        ticketMedio: {
          inicioKey: "inicio_tm",
          fimKey: "fim_tm",
          onlyKey: "only_ticket_medio",
          loadingKey: "loadingTicketMedio",
          stateKey: "ticketMedio",
          periodoKey: "tmPeriodo",
        },
        margemLucro: {
          inicioKey: "inicio_margem",
          fimKey: "fim_margem",
          onlyKey: "only_margem_lucro",
          loadingKey: "loadingMargemLucro",
          stateKey: "margemLucro",
          periodoKey: "margemPeriodo",
        },
        valorVendas: {
          inicioKey: "inicio_vendas",
          fimKey: "fim_vendas",
          onlyKey: "only_vendas",
          loadingKey: "loadingValorVendas",
          stateKey: "valorVendas",
          periodoKey: "valorVendas",
        },
        produtosMaisVendidos: {
          inicioKey: "inicio_produtos",
          fimKey: "fim_produtos",
          onlyKey: "only_produtos",
          loadingKey: "loadingTopProdutos",
          stateKey: "produtosMaisVendidos",
          periodoKey: "produtosPeriodo",
        },
        inadimplencia: {
          inicioKey: "inicio_inadimplencia",
          fimKey: "fim_inadimplencia",
          onlyKey: "only_inadimplencia",
          loadingKey: "loadingInadimplencia",
          stateKey: "inadimplencia",
          periodoKey: "inadimplenciaPeriodo",
        },
        relacaoFinanceira: {
          inicioKey: "inicio_relacao_fina",
          fimKey: "fim_relacao_fina",
          onlyKey: "only_relacao_financeira",
          loadingKey: "loadingRelacaoFinanceira",
          stateKey: "relacaoFinanceira",
          periodoKey: "relacaoFinanceiraPeriodo",
        },
        clientesTop: {
          inicioKey: "inicio_cliente",
          fimKey: "fim_cliente",
          onlyKey: "only_clientes",
          loadingKey: "loadingMaioresClientes",
          stateKey: "clientesTop",
          periodoKey: "clientesPeriodo",
        },
      };
    },
    ...mapGetters(["currentUser"]),
  },
  async created() {
    this.resetFiltrosDefault();
    this.fetchDashboard();

    const response = await this.$http.post("/empresa/validade-certificado", {
      id: this.currentUser.usuario_empresa.id_empresa,
    });
    this.certificadoVencidoMsg = response?.data.mensagem ?? "";
  },

  methods: {
    resetFiltrosDefault() {
      const hoje = (() => {
        const d = new Date();
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
        return d.toISOString().slice(0, 10);
      })();
      this.filtros = { inicio_tm: hoje, fim_tm: hoje };
      this.tmPeriodo = null; // <-- volta a null no reset
      this.relacaoVendas = [];
      this.loadingGraficoVendas = false;
    },

    async fetchDashboard() {
      try {
        this.loadingTotais = true;
        this.loadingTicketMedio = true;
        this.loadingMargemLucro = true;
        this.loadingValorVendas = true;
        this.loadingInadimplencia = true;
        this.loadingRelacaoFinanceira = true;
        this.loadingAniversariantes = true;
        this.loadingTopProdutos = true;
        this.loadingMaioresClientes = true;
        this.loadingGraficoVendas = true;
        this.loadingMeta = true;
        const hoje = this.filtros.inicio_tm; // já é hoje

        const { data } = await this.$http.post("/dashboard/totais-dashboard", {
          inicio_inadimplencia: hoje,
          fim_inadimplencia: hoje,
          inicio_relacao_fina: this.semana.inicio,
          fim_relacao_fina: this.semana.fim,
          inicio_tm: hoje,
          fim_tm: hoje,
          inicio_vendas: hoje,
          fim_vendas: hoje,
          inicio_produtos: hoje,
          fim_produtos: hoje,
          inicio_margem: hoje,
          fim_margem: hoje,
          inicio_cliente: hoje,
          fim_cliente: hoje,
          mode: "ano",
          periodo_a: null,
          periodo_b: null,
        });

        if (data.totais_cadastros) {
          this.totais_cadastros = data.totais_cadastros;
          this.loadingTotais = false;
        }
        if (data.totais_financeiros) {
          this.totais_financeiros = data.totais_financeiros;
        }
        if (data.ticketMedio) {
          this.ticketMedio = data.ticketMedio;
          this.loadingTicketMedio = false;
        }
        if (data.margemLucro) {
          this.margemLucro = data.margemLucro;
          this.loadingMargemLucro = false;
        }
        if (data.valorVendas) {
          this.valorVendas = data.valorVendas;
          this.loadingValorVendas = false;
        }
        if (data.inadimplencia) {
          this.inadimplencia = data.inadimplencia;
          this.loadingInadimplencia = false;
        }
        if (data.relacaoFinanceira) {
          this.relacaoFinanceira = data.relacaoFinanceira;
          this.loadingRelacaoFinanceira = false;
        }
        if (data.aniversariantes) {
          this.aniversariantes = data.aniversariantes;
          this.loadingAniversariantes = false;
        }
        if (data.produtosMaisVendidos) {
          this.produtosMaisVendidos = data.produtosMaisVendidos;
          this.loadingTopProdutos = false;
        }
        if (data.clientesTop) {
          this.clientesTop = data.clientesTop;
          this.loadingMaioresClientes = false;
        }
        if (data.relacaoVendas) {
          this.relacaoVendas = data.relacaoVendas;
          this.loadingGraficoVendas = false;
        }
        if (data.meta) {
          this.metaMensal = data.meta;
          this.loadingMeta = false;
        }
      } finally {
        this.loadingTotais = false;
        this.loadingTicketMedio = false;
        this.loadingMargemLucro = false;
        this.loadingValorVendas = false;
        this.loadingInadimplencia = false;
        this.loadingRelacaoFinanceira = false;
        this.loadingAniversariantes = false;
        this.loadingTopProdutos = false;
        this.loadingMaioresClientes = false;
        this.loadingGraficoVendas = false;
        this.loadingMeta = false;
      }
    },

    async fetchIndicadorOnly(tipo, inicio, fim) {
      const cfg = this.INDICADORES[tipo];
      if (!cfg) {
        console.warn(`Indicador desconhecido: ${tipo}`);
        return;
      }

      try {
        this[cfg.loadingKey] = true;

        const payload = {
          [cfg.inicioKey]: inicio,
          [cfg.fimKey]: fim,
          [cfg.onlyKey]: true,
        };

        const { data } = await this.$http.post(
          "/dashboard/totais-dashboard",
          payload
        );

        // Atualiza estado se veio a chave esperada
        if (Object.prototype.hasOwnProperty.call(data, cfg.stateKey)) {
          this[cfg.stateKey] = data[cfg.stateKey];
        }
      } catch (e) {
        this.$toast?.danger?.(
          "Houve algum problema, chame um consultor da Nuts!"
        );
        console.error(e);
      } finally {
        this[cfg.loadingKey] = false;
      }
    },

    // Handler único para mudança de período
    onPeriodoChange(tipo, { inicio, fim }) {
      const cfg = this.INDICADORES[tipo];
      if (!cfg) return;

      // Atualiza filtros e período correspondente
      this.filtros = {
        ...this.filtros,
        [cfg.inicioKey]: inicio,
        [cfg.fimKey]: fim,
      };
      this[cfg.periodoKey] = { inicio, fim };

      // Dispara a busca do indicador
      this.fetchIndicadorOnly(tipo, inicio, fim);
    },
    async onComparacaoVendas({ modeId, a, b }) {
      this.loadingGraficoVendas = true;
      try {
        const { data } = await this.$http.post("/dashboard/totais-dashboard", {
          mode: modeId,
          only_comparativo_vendas: true,
        });
        this.relacaoVendas = data.relacaoVendas;
        this.loadingGraficoVendas = false;
      } catch (e) {
        this.$toast?.danger(
          "Não foi possível carregar o comparativo de vendas."
        );
      } finally {
        this.loadingGraficoVendas = false;
      }
    },
  },
};
</script>

<style>
.dash-widget .card-body {
  padding: 0;
}
</style>

<style scoped>
@media (min-width: 1840px) {
  .d-xxxl-block {
    display: block !important;
  }
  .d-xxxl-none {
    display: none !important;
  }
  .col-xxxl-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  .col-xxxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
